<template>
    <div>
        <div class="modal hide fade" id="modalSaleOrderFilter" tabindex="-1" role="dialog" aria-labelledby="modalSaleOrderFilter" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Filter
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label for="recipient-name" class="col-form-label">Begin:</label>
                                <datetime v-model="begin" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="Asia/Jakarta" zone="Asia/Jakarta"></datetime>
                            </div>
                            <div class="form-group">
                                <label for="message-text" class="col-form-label">End:</label>
                                <datetime v-model="end" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="Asia/Jakarta" zone="Asia/Jakarta"></datetime>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-hard-primary" data-dismiss="modal" @click="filter">Filter</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'SaleSalesmanOrderModal',
  data () {
    return {
      begin: null,
      end: null
    }
  },
  methods: {
    filter () {
      var obj = {
        begin: this.begin,
        end: this.end
      }
      this.$emit('filter', obj)
    }
  }
}
</script>
